import React from 'react';
import CrmLeads from '../Crm/CrmLeads';

const PortalLeads = () => {
  return (
    <React.Fragment>
      <CrmLeads />
    </React.Fragment>
  );
};

export default PortalLeads;
